import { render, staticRenderFns } from "./subconCategoryTree.vue?vue&type=template&id=167c8c4a&"
import script from "./subconCategoryTree.vue?vue&type=script&lang=js&"
export * from "./subconCategoryTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports